<template>
    <v-autocomplete
    v-model="localSelectedID"
    :items="items"
    :search-input.sync="search"
    :filter="customFilter"
    item-text="symbol"
    item-value="id"
    placeholder="Search..."
    hide-details
    spellcheck="false"
    solo
    color="color1"
    :clearable="clearable">

    <template
    slot="selectionn"
    slot-scope="{ item }">
      <div style="display: flex;flex-wrap:nowrap;align-items:center;">
        <span class="blue-grey--text">
          {{ item.name }}
        </span>
      </div>
    </template>

    <template 
    slot="no-data">
      <v-list-item>
        <v-list-item-title>
          No matching
          <strong>currencies</strong>
        </v-list-item-title>
      </v-list-item>
    </template>

    <template
    slot="item"
    slot-scope="{ item }">

    <v-list-item-avatar
    color="red lighten-2"
    class="headline font-weight-light white--text">
      {{ item.name.charAt(0) }}
    </v-list-item-avatar>
    <v-list-item-content>
      <v-list-item-title v-html="highlight(item.name)"></v-list-item-title>
      <v-list-item-subtitle v-text="item.symbol"></v-list-item-subtitle>
    </v-list-item-content>

    </template>

    </v-autocomplete>
</template>

<script>
export default {
  props: {
    selectedID: null,
    clearable: false
  },
  data () {
    return {
      search: ''
    }
  },
  computed: {
    items () {
      return Object.values(this.$store.state.db.currencies.items)
    },
    keywords () {
      return (this.search || '').toLowerCase().split(' ')
    },
    localSelectedID: {
      get () {
        return this.selectedID
      },
      set (nv) {
        this.$emit('update:selectedID', nv)
        this.$emit('change', this.items.find(item => item.id === nv))
      }
    }
  },
  methods: {
    customFilter (item, queryText, itemText) {
      return this.keywords.every(keyword => {
        return (item.name + ' ' + item.symbol).toLowerCase().indexOf(keyword) > -1
      })
    },
    highlight (str) {
      var replacedStr = (this.search || '').trim().split(/\s+/).map(x => x.replace(/[-[\]{}()*+!<=:?.\\^$|#\s,]/g, '\\$&')).join('|')
      return str.replace(new RegExp(replacedStr, 'gi'), '<span class="font-weight-bold">$&</span>')
    }
  }
}
</script>

